export default __webpack_public_path__ + "static/media/input.784bdfec.svg";